import { NETWORK_ACTION, NETWORK_PATH } from '../../constants'
import getRequestsNetworkSelect from '../../selectors/get-requests'
import { getActionTypeNetworkRequestUtil } from '../../utils'
import { getPathNetworkUtil } from '../../utils/get-path'
import { getStatusNetworkUtil } from '../../utils/get-status'
import setReduxAction from '../../../redux/actions/set'
import REDUX_STATUS from '../../../redux/constants/status'
import { logUtil } from 'packages/src'

function deleteRequestNetworkAction (action) {
  return (dispatch, getState) => {
    const requests = getRequestsNetworkSelect(getState())
    if (!requests.length) {
      logUtil('').debug('[noop]')
      return
    }

    const status = (
      getStatusNetworkUtil({ action }, getState())
    )
    const path = getPathNetworkUtil({ action })
    // logUtil('').debug('action: ', action)
    // logUtil('').debug('status: ', status)
    // logUtil('').debug('path: ', path)
    // logUtil('').debug('requests: ', requests)
    const newRequests = (
      requests.filter(request => {
        const reqStatus = getStatusNetworkUtil(request, getState())
        // logUtil('').debug('request:', request)
        // logUtil('').debug('action?.type: ', action?.type)
        const shouldKeep = (
          getPathNetworkUtil(request) !==
          path ||
          getActionTypeNetworkRequestUtil(request) !==
          action?.type ||
          (
            getPathNetworkUtil(request) === path && reqStatus !== status && [
              REDUX_STATUS.SAVING,
              REDUX_STATUS.LOADING
            ].includes(reqStatus) && [
              REDUX_STATUS.SAVING,
              REDUX_STATUS.LOADING
            ].includes(status)
          )
        )
        if (!shouldKeep) {
          // logUtil('').debug('request to delete: ', request)
        }
        return shouldKeep
      })
    )

    // logUtil('').debug('newRequests: ', newRequests)
    if (requests.length === newRequests.length) {
      console.warn('request not deleted with action %o and requests %o',
        action,
        requests
      )
      return
    }

    dispatch(setReduxAction({
      type: NETWORK_ACTION.DELETE_REQUEST,
      payload: {
        path: NETWORK_PATH.REQUESTS,
        value: newRequests
      }
    }))
  }
}

export default deleteRequestNetworkAction
